import { type ApisauceInstance, create } from 'apisauce';
import { broadcastService } from '@/services';
import { ENV } from '@/constants';

const apiClient = create({
	baseURL: `${ENV.baseUrlApi}/api`,
	headers: { 'accept-language': 'fr' },
	timeout: 30000 // 30 seconds
}) as ApisauceInstance;

// Add a response interceptor
apiClient.axiosInstance.interceptors.response.use(
	response => response,
	error => {
		error?.request?.status === 0 &&
			broadcastService.events.publish({
				type: 'apiServerDisconnected',
				data: error
			});

		return Promise.reject(error);
	}
);

export { apiClient };
